import TestLog from './TestLog.vue';

export default TestLog;